import { createContext, useContext } from 'react';

export type PsapPortalFeatures = {
  allowEmergencyCallNotification: boolean;
};

export type PsapPortalConfiguration = {
  appName?: string | null;
  themeColor?: string | null;
  logoFolderPath?: string | null;
  psapPortalFeatures: PsapPortalFeatures;
};

export type PsapConfiguration = {
  id: string;
  psapPortalConfiguration: PsapPortalConfiguration;
};

export const PsapConfigurationContext = createContext<PsapConfiguration | null>(null);

export function usePsapConfiguration(): PsapConfiguration | null {
  return useContext(PsapConfigurationContext);
}
